/** @format */
export function listDokumen() {
  const dataTableDokumen = [
    {
      key: "docLpj1",
      nama: "Laporan Pertanggung Jawaban (LPJ) Desember 2023",
      kode: 1,
      tahap: 1,
      doc: null, //"/doc/Format_LPJ_Manual.xlsx",
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    {
      key: "docLpj1",
      nama: "Laporan Pertanggung Jawaban (LPJ) Juni 2024 atau bulan selanjutnya",
      kode: 1,
      tahap: 2,
      doc: null, //"/doc/Format_LPJ_Manual.xlsx",
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    {
      key: "docSPPD",
      nama: "Surat Pernyataan Madrasah Tidak Menerima Dana BOS TA. 2023",
      kode: 8,
      tahap: 1,
      doc: "/doc/Lampiran_Bukan_Penerima_Bantuan_2023.docx",
      type: "application/pdf",
    },
    {
      key: "docSPPD",
      nama: "Surat Pernyataan Madrasah Tidak Menerima Dana BOS Tahap 2 TA. 2023",
      kode: 8,
      doc: "/doc/Lampiran_Bukan_Penerima_Bantuan_2023.docx",
      tahap: 2,
      type: "application/pdf",
    },
    {
      key: "docPPDB2",
      nama: "Surat Permohonan Pencairan Dana BOS Tahap 1 TA. 2024",
      kode: 2,
      tahap: 1,
      doc: "/doc/Surat_Permohonan_Pencairan_Dana_BOS_TA_2024.docx",
      type: "application/pdf",
    },
    {
      key: "docPPDB2",
      nama: "Surat Permohonan Pencairan Dana BOS Tahap 2 TA.2024",
      kode: 2,
      tahap: 2,
      doc: "/doc/Surat_Permohonan_Pencairan_Dana_BOS_TA_2024.docx",
      type: "application/pdf",
    },
    {
      key: "docPTJM3",
      nama: "Surat Pernyataan Tanggung Jawab Mutlak",
      kode: 3,
      tahap: 1,
      doc: "/doc/Formulir_SPTJM_BOS_2024.docx",
      type: "application/pdf",
    },
    {
      key: "docPTJM3",
      nama: "Surat Pernyataan Tanggung Jawab Mutlak",
      kode: 3,
      tahap: 2,
      doc: "/doc/Formulir_SPTJM_BOS_2024.docx",
      type: "application/pdf",
    },
    // {
    //   key: "docPTJB4",
    //   nama: "Surat Pernyataan Tanggung Jawab Belanja",
    //   kode: 4,
    //   tahap: 2,
    //   doc: null,
    // },
    {
      key: "docPPK5",
      nama: "Surat Perjanjian Kerjasama",
      kode: 4,
      tahap: 1,
      doc: null,
      type: "application/pdf",
    },
    {
      key: "docPPK5",
      nama: "Surat Perjanjian Kerjasama",
      kode: 4,
      tahap: 2,
      doc: null,
      type: "application/pdf",
    },
    {
      key: "docRKAM6",
      nama: "Rencana Kerja Anggaran Madrasah (RKAM)",
      kode: 5,
      tahap: 1,
      doc: null,
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    {
      key: "docRKAM6",
      nama: "Rencana Kerja Anggaran Madrasah (RKAM)",
      kode: 5,
      tahap: 2,
      doc: null,
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    {
      key: "docKPBT7",
      nama: "Kuitansi Penerimaan Bantuan Tahap 1 TA. 2024",
      kode: 6,
      tahap: 1,
      doc: "/doc/Kuitansi_Penerimaan_BOS_2024_1.docx",
      type: "application/pdf",
    },
    {
      key: "docKPBT7",
      nama: "Kuitansi Penerimaan Bantuan Tahap 2 TA. 2024",
      kode: 6,
      tahap: 2,
      doc: "/doc/Kuitansi_Penerimaan_BOS_2024_1.docx",
      type: "application/pdf",
    },
    {
      key: "docBPD",
      nama: "Bukti Pengembalian Dana Tahap 2 TA. 2023",
      kode: 7,
      tahap: 1,
      doc: "/doc/Kuitansi_Penerimaan_BOS_2024.docx",
      type: "application/pdf",
    },
    // {
    //   key: "docBPD",
    //   nama: "Bukti Pengembalian Dana Tahap 2 TA. 2023",
    //   kode: 7,
    //   tahap: 2,
    //   doc: "/doc/Kuitansi_Penerimaan_BOS_2024.docx",
    //   type: "application/pdf",
    // },
    {
      key: "docSPTJB",
      nama: "Surat Pernyataan Tanggung Jawab Belanja Kepala Madrasah dan PPK",
      kode: 11,
      tahap: 2,
      doc: "/doc/BOS-SPTJB.docx",
      type: "application/pdf",
    },
    {
      key: "docBAPE",
      nama: "Dokumen BAP BOS 30 September 2023",
      kode: 10,
      tahap: 1,
      doc: null,
      type: "application/pdf",
    },
    // {
    //   key: "docBAPE",
    //   nama: "Dokumen BAP BOS 30 Juni 2024",
    //   kode: 10,
    //   tahap: 2,
    //   doc: null,
    //   type: "application/pdf",
    // },
    {
      key: "docTBUP",
      nama: `Tanda Bukti Upload Pencairan Dana BOS TA. 2024`,
      kode: 9,
      tahap: 1,
      doc: null,
    },
    {
      key: "docTBUP",
      nama: "Tanda Bukti Upload Pencairan Dana BOS TA. 2024",
      kode: 9,
      tahap: 2,
      doc: null,
    },
  ];
  return dataTableDokumen;
}

export const validasiListDokumen = (type: any, tahap: any, penerima: any) => {
  if (type === "R") {
    const listDoc: any = [
      {
        list: [2, 3, 4, 7, 6, 10],
        tahap: 1,
        penerimaBos: 1,
      },
      {
        list: [8, 2, 3, 4, 7, 6, 10],
        tahap: 1,
        penerimaBos: 0,
      },
      {
        list: [2, 6, 11],
        tahap: 2,
        penerimaBos: 1,
      },
      {
        list: [8, 2, 11, 6],
        tahap: 2,
        penerimaBos: 0,
      },
      {
        list: [2, 3, 4, 6],
        tahap: 2,
        penerimaBos: 2,
      },
      {
        list: [8, 2, 3, 4, 6],
        tahap: 2,
        penerimaBos: 3,
      },
    ];

    let dataList: any =
      listDoc.find(
        (item) => item.tahap === tahap && item.penerimaBos === penerima,
      ) || null;

    return dataList?.list;
  } else {
    const listdocManual: any = [
      {
        list: [1, 2, 3, 4, 5, 6, 10],
        tahap: 1,
        penerimaBos: 1,
      },
      {
        list: [8, 2, 3, 4, 5, 6, 10],
        tahap: 1,
        penerimaBos: 0,
      },
      {
        list: [1, 2, 5, 6, 11],
        tahap: 2,
        penerimaBos: 1,
      },
      {
        list: [8, 2, 5, 6, 11],
        tahap: 2,
        penerimaBos: 0,
      },
      {
        list: [1, 2, 3, 4, 5, 6],
        tahap: 2,
        penerimaBos: 2,
      },
      {
        list: [2, 3, 4, 5, 6, 8],
        tahap: 2,
        penerimaBos: 3,
      },
    ];
    let dataList: any =
      listdocManual.find(
        (item: any) =>
          item.tahap.toString() === tahap &&
          item.penerimaBos.toString() === penerima,
      ) || null;
    return dataList?.list;
  }

  // return listdoc;
};

export const getTanggalPengajuanBos = () => {
  const listJadwal: any = [
    {
      startDate: "2024-01-15 08:00:00",
      endDate: "2024-01-23 17:00:00",
      tahap: 1,
      batch: 1,
    },
    {
      startDate: "2024-01-27 00:00:00",
      endDate: "2024-02-08 17:00:00",
      tahap: 1,
      batch: 2,
    },
    {
      startDate: "2024-02-15 08:00:00",
      endDate: "2024-02-20 17:00:00",
      tahap: 1,
      batch: 3,
    },
    {
      startDate: "2024-02-24 08:00:00",
      endDate: "2024-02-29 17:00:00",
      tahap: 1,
      batch: 4,
    },
    {
      startDate: "2024-04-23 08:00:00",
      endDate: "2024-05-12 17:00:00",
      tahap: 1,
      batch: 5,
    },
    {
      startDate: "2024-05-22 08:00:00",
      endDate: "2024-05-30 17:00:00",
      tahap: 1,
      batch: 6,
    },
    {
      startDate: "2024-08-13 08:00:00",
      endDate: "2024-08-22 17:00:00",
      tahap: 2,
      batch: 1,
    },
    {
      startDate: "2024-08-30 08:00:00",
      endDate: "2024-09-08 17:00:00",
      tahap: 2,
      batch: 2,
    },
    {
      startDate: "2024-09-15 08:00:00",
      endDate: "2024-09-22 17:00:00",
      tahap: 2,
      batch: 3,
    },
    {
      startDate: "2024-10-01 08:00:00",
      endDate: "2024-10-21 17:00:00",
      tahap: 2,
      batch: 4,
    },
    {
      startDate: "2024-11-05 08:00:00",
      endDate: "2024-12-31 17:00:00",
      tahap: 2,
      batch: 5,
    },
  ];
  return listJadwal;
};

export const getStatusDokumen = (status: any) => {
  let statusDokumen: any = [
    {
      status: {
        color: "",
        infoMessage: "Ajukan Dokumen",
        toolstips:
          "Lengkapi kelengkapan dokumen lalu ajukan untuk proses verifikasi",
      },
      kode: 0,
    },
    {
      status: {
        color: "red",
        infoMessage: "Revisi Dokumen",
        toolstips:
          "Revisi dokumen yang di tolak oleh verifikator, lalu ajukan kembali untuk proses verifikasi",
      },
      kode: 1,
    },
    {
      status: {
        color: "blue",
        infoMessage: "Verifikasi",
        toolstips:
          "Proses Dokumen sedang di verifikasi oleh verifikator kabkota/provinsi",
      },
      kode: 2,
    },
    {
      status: {
        color: "blue",
        infoMessage: "Disetujui Verifikator",
        toolstips:
          "Proses Dokumen berhasil disetujui dan diajukan ke team pusat",
      },
      kode: 3,
    },
    {
      status: {
        color: "blue",
        infoMessage: "Pengajuan",
        toolstips: "Proses Dokumen sedang diajukan oleh pusat ke pihak Bank",
      },
      kode: 4,
    },
    {
      status: {
        color: "blue",
        infoMessage: "Penyaluran",
        toolstips:
          "Proses pihak Bank melakukan penyaluran alokasi dana ke rekening Lembaga",
      },
      kode: 5,
    },
    {
      status: {
        color: "green",
        infoMessage: "Pencairan",
        toolstips:
          "Lembaga sudah bisa mencairkan dana dengan cara mendownload bukti pencairan",
      },
      kode: 6,
    },
    {
      status: {
        color: "green",
        infoMessage: "DiCairkan",
        toolstips: "Lembaga sudah mencairkan dana alokasi",
      },
      kode: 7,
    },
  ];
  return statusDokumen.find((item) => item.kode === status) || null;
};

export const checkDataErkam = (
  dataLapErkam: any,
  tmpRencanaPendapatan: any,
) => {
  let result = true;
  const listSumberBos = [
    "apbn_bos_semester_1",
    "apbn_bos_semester_2",
    "apbn_bos_triwulan_1",
    "apbn_bos_triwulan_2",
    "apbn_bos_triwulan_3",
    "apbn_bos_triwulan_4",
  ];
  let totalPendapatan = 0;
  let totalBelanja = 0;

  tmpRencanaPendapatan?.length &&
    // eslint-disable-next-line array-callback-return
    tmpRencanaPendapatan.map((item) => {
      totalPendapatan += item?.jumlah;
    });

  dataLapErkam?.length &&
    // eslint-disable-next-line array-callback-return
    dataLapErkam?.map((item) => {
      if (listSumberBos.includes(item?.kodeSumberDana)) {
        totalBelanja += item?.rencanaBelanja;
        // totalPendapatan += item?.rencanaPendapatan;
      }
    });

  if (totalPendapatan === 0 || totalBelanja === 0) {
    result = true;
  } else if (totalPendapatan !== totalBelanja) {
    result = true;
  } else {
    result = false;
  }
  // let dataTahap1: any =
  //   (dataLapErkam.length &&
  //     dataLapErkam.find(
  //       (item: any) => item?.kodeSumberDana === "apbn_bos_semester_1",
  //     )) ||
  //   null;
  // let dataTahap2: any =
  //   (dataLapErkam.length &&
  //     dataLapErkam.find(
  //       (item: any) => item?.kodeSumberDana === "apbn_bos_semester_2",
  //     )) ||
  //   null;
  // if (tmpSpesialBOSTahap2) {
  //   if (!dataTahap2) {
  //     result = true;
  //   } else if (dataTahap2?.rencanaPendapatan !== dataTahap2?.rencanaBelanja) {
  //     result = true;
  //   } else {
  //     result = false;
  //   }
  // } else {
  //   if (!dataTahap1 || !dataTahap2) {
  //     result = true;
  //   } else if (dataTahap1?.rencanaPendapatan !== dataTahap1?.rencanaBelanja) {
  //     result = true;
  //   } else if (dataTahap2?.rencanaPendapatan !== dataTahap2?.rencanaBelanja) {
  //     result = true;
  //   } else {
  //     result = false;
  //   }
  // }

  return result;
};

export const checkDataLpj = (
  dataRealisasi: any,
  dataSumber: any,
  checkDataMadrasah: any,
) => {
  let notifLpj: any = null;
  const listSumberTriwulan = [
    {
      sumberDana: "apbn_bos_semester_1",
      desc: "Tahap 1",
    },
    {
      sumberDana: "apbn_bos_semester_2",
      desc: "Tahap 2",
    },
    {
      sumberDana: "apbn_bos_triwulan_1",
      desc: "Triwulan 1",
    },
    {
      sumberDana: "apbn_bos_triwulan_2",
      desc: "Triwulan 2",
    },
    {
      sumberDana: "apbn_bos_triwulan_3",
      desc: "Triwulan 3",
    },
    {
      sumberDana: "apbn_bos_triwulan_4",
      desc: "Triwulan 4",
    },
  ];
  const sumberCheckLpj =
    listSumberTriwulan.find(
      (item: any) => item.sumberDana === checkDataMadrasah?.periode?.sumberDana,
    ) || null;

  if (dataRealisasi && sumberCheckLpj && checkDataMadrasah) {
    let tmpSumberRealisasi: any = [];
    dataRealisasi?.header3.length &&
      // eslint-disable-next-line array-callback-return
      dataRealisasi?.header3.map((item: any) => {
        item?.details.length &&
          item?.details
            .filter((iitem) => iitem.sumber_dana === sumberCheckLpj?.sumberDana)
            .map((iitem) => tmpSumberRealisasi.push(iitem));
      });
    let tmpPendapatan = 0;
    let tmpPengeluaran = 0;

    tmpSumberRealisasi.length &&
      // eslint-disable-next-line array-callback-return
      tmpSumberRealisasi.map((item) => {
        tmpPendapatan += item.pendapatan;
        tmpPengeluaran += item.pengeluaran;
      });
    let persen = Math.round((tmpPengeluaran / tmpPendapatan) * 100);

    if (persen <= 80) {
      notifLpj = `Transaksi realisasi untuk ${sumberCheckLpj?.desc} masih ${persen}%`;
    } else if (isNaN(persen)) {
      notifLpj = "Madrasah belum melakukan transaksi realisasi";
    }
  }

  return notifLpj;
};

export const checkPenerimaBOSID = (status: any) => {
  return (status === 4 && 0) || status;
};

export const checkFileDok = (
  fileList: any,
  kode: any,
  tahap: any,
  statusBos: any,
) => {
  return (
    fileList.find(
      (item) =>
        item.kodeDok === kode &&
        item.tahap === tahap &&
        item.penerimaBos === checkPenerimaBOSID(statusBos),
    ) || null
  );
};

export const normalizeNamaDok = (value: any) =>
  (value || "").toString().trim().toLowerCase();

/**
 * Kumpulkan semua `kode_id` yang mewakili dokumen logis yang sama lintas batch
 * pengajuan BOS.
 *
 * `kode_id` diketik ulang admin setiap batch dibuka sehingga tidak stabil,
 * sedangkan `nama` dokumen konsisten — jadi `nama` dipakai sebagai korelator.
 * Scope tetap ketat: hanya batch (`djadwal_pengajuan_id`) yang dilonggarkan,
 * kriteria penerima BOS harus sama.
 *
 * @returns `[kode_id batch aktif, ...kode_id batch lain]`
 */
export const getKodeDokLintasBatch = (
  dataTableDokumen: any,
  record: any,
  siblingJadwalIds: any,
  penerimaBos: any,
): any[] => {
  const kodeAktif: any = record?.kode_id;

  if (!record?.nama || !siblingJadwalIds?.length) return [kodeAktif];

  const namaRecord: string = normalizeNamaDok(record?.nama);
  const kodeSibling: any[] =
    (dataTableDokumen || [])
      .filter(
        (item) =>
          normalizeNamaDok(item?.nama) === namaRecord &&
          siblingJadwalIds.includes(item?.djadwal_pengajuan_id) &&
          item?.penerima_bos?.toString() === penerimaBos?.toString(),
      )
      .map((item) => item?.kode_id) || [];

  return [kodeAktif, ...kodeSibling].filter(
    (kode) => kode !== null && kode !== undefined,
  );
};

/**
 * Ambil semua file dokumen BOS untuk sekumpulan `kodeDok`, ter-scope ke tahap
 * dan kriteria penerima BOS, terurut dari yang paling baru diupload.
 */
export const getFilesDokByKode = (
  fileList: any,
  kodeIds: any,
  tahap: any,
  statusBos: any,
): any[] => {
  const penerimaBos: any = checkPenerimaBOSID(statusBos);

  return (
    (fileList || [])
      .filter(
        (item) =>
          (kodeIds || []).includes(item?.kodeDok) &&
          item?.tahap === tahap &&
          item?.penerimaBos?.toString() === penerimaBos?.toString(),
      )
      .sort(
        (a, b) =>
          new Date(b?.created_at).getTime() - new Date(a?.created_at).getTime(),
      ) || []
  );
};

export const getLaporanDokumenPengajuan = () => [
  {
    code: "docLpj",
    name: "Laporan Pertanggung Jawaban",
  },
  {
    code: "docRkam",
    name: "Laporan RKAM",
  },
];

export const getFirstSumberDanaBOS = () => [
  "apbn_bos_semester_1",
  "apbn_bos_triwulan_1",
];

export const getNamePenerimaBOS = () => [
  {
    kode: 3,
    name: "Penerima Baru",
    desc: "Diperuntukan bagi Madrasah/RA yang telah ditetapkan sebagai penerima baru BOS/BOP TA 2026 dan tidak melakukan pengajuan Tahap 1",
  },
  {
    kode: 1,
    name: "Penerima Tahun Sebelumnya",
    desc: "Diperuntukan bagi Madrasah/RA yang telah mendapatkan BOS/BOP TA 2025 dan telah ditetapkan sebagai penerima BOS/BOP TA 2026 dan tidak melakukan pengajuan BOS/BOP TA 2025 pada Tahap 1",
  },
  {
    kode: 2,
    name: "Penerima Triwulan I",
    desc: "Diperuntukan bagi Madrasah/RA yang telah mendapatkan BOS/BOP TA 2025 Pada Triwulan I dan tidak melakukan pengajuan Triwulan II",
  },
  {
    kode: 4,
    name: "Penerima Triwulan II",
    desc: "Diperuntukan bagi Madrasah/RA yang telah mendapatkan BOS/BOP TA 2025 Pada Triwulan II dan tidak melakukan pengajuan Triwulan I",
  },
  {
    kode: 5,
    name: "Penerima Triwulan I dan II",
    desc: "Diperuntukan bagi Madrasah/RA yang telah mendapatkan BOS/BOP TA 2025 Pada Triwulan I dan II",
  },
  {
    kode: 6,
    name: "Penerima Tahap 1",
    desc: "Diperuntukan bagi Madrasah/RA yang telah mendapatkan BOS/BOP TA 2026 dan telah melakukan pengajuan di Tahap I",
  },
];

export const checkDataNilai = (dataBos: any, dataSumber: any) => {
  let nilaiTahap: any = 0;
  if (dataBos && dataSumber) {
    switch (dataSumber) {
      case "apbn_bos_semester_1":
        nilaiTahap = dataBos?.apbn_bos_semester1 || 0;
        break;
      case "apbn_bos_semester_2":
        nilaiTahap = dataBos?.apbn_bos_semester2 || 0;
        break;
      case "apbn_bos_triwulan_1":
        nilaiTahap = dataBos?.apbn_bos_triwulan1 || 0;
        break;
      case "apbn_bos_triwulan_2":
        nilaiTahap = dataBos?.apbn_bos_triwulan2 || 0;
        break;

      case "apbn_bos_triwulan_3":
        nilaiTahap = dataBos?.apbn_bos_triwulan3 || 0;
        break;
      case "apbn_bos_triwulan_4":
        nilaiTahap = dataBos?.apbn_bos_triwulan4 || 0;
        break;
    }
  }
  return nilaiTahap;
};

export const getBeforeSumberDanaTahap = (sumberDana: any) => {
  let title = "";
  switch (sumberDana) {
    case "apbn_bos_semester_2":
      title = "APBN BOS Semester 1";
      break;
    case "apbn_bos_triwulan_2":
      title = "APBN BOS Triwulan 1";
      break;
    case "apbn_bos_triwulan_3":
      title = "APBN BOS Triwulan 2";
      break;
    case "apbn_bos_triwulan_4":
      title = "APBN BOS Triwulan 3";
      break;
  }
  return title;
};

export const getSumberDanaTahap = (sumberDana: any) => {
  let tahap = 0;
  switch (sumberDana) {
    case "apbn_bos_semester_1":
    case "apbn_bos_triwulan_1":
      tahap = 1;
      break;
    case "apbn_bos_semester_2":
    case "apbn_bos_triwulan_2":
      tahap = 2;
      break;
    case "apbn_bos_triwulan_3":
      tahap = 3;
      break;
    case "apbn_bos_triwulan_4":
      tahap = 4;
      break;
    default:
      tahap = 4;
      break;
  }
  return tahap;
};

export const filterByRoleKabkotaOrProv = (role: any, tmpList: any) => {
  return role === "provinsi"
    ? (tmpList.length &&
        tmpList.filter((item) => item.jenjangMadrasah === "ma")) ||
        []
    : (tmpList.length &&
        tmpList.filter((item) => item.jenjangMadrasah !== "ma")) ||
        [];
};

export const spesialBOSPengajuan = () => {
  return [];
};

export const spesialBOSTahap2 = () => {
  return [];
};
